module.exports = __webpack_public_path__ + "static/media/logo.1a64d163.png";